// Pure geometry/parse helpers for defect-image annotations (rectangles and
// arrows). No React dependency — extracted from DefectsImageGallery.tsx.

import { DrawableCollection } from './defectImageTypes';

export const getRectangleTLBR = (rect: any[]) => {
  const rectangle = [];

  rectangle[0] = Math.min(rect[2], rect[0]);
  rectangle[2] = Math.max(rect[2], rect[0]);
  rectangle[1] = Math.min(rect[1], rect[3]);
  rectangle[3] = Math.max(rect[1], rect[3]);

  return rectangle;
};

export const getRectangleStyle = (rect: any[]) => {
  if (rect === null || !Array.isArray(rect) || rect.length < 4) {
    return {};
  }

  const rectangle = getRectangleTLBR(rect);

  const left = (rectangle[0] || 0) * 100 + '%';
  const top = (rectangle[1] || 0) * 100 + '%';
  const right = (1 - rectangle[2]) * 100 + '%';
  const bottom = (1 - rectangle[3]) * 100 + '%';

  return {
    left: left,
    top: top,
    bottom: bottom,
    right: right,
    borderColor: '#00ff00',
    borderStyle: 'solid',
    borderWidth: '3px',
    position: 'absolute',
    zIndex: 99,
    pointerEvents: 'none',
  };
};

export const eventToPointPercentage = (event: any) => {
  let iBounds = [
    event.target.getBoundingClientRect().left,
    event.target.getBoundingClientRect().top,
  ];

  return [
    Math.max(
      Math.min((event.clientX - iBounds[0]) / event.target.offsetWidth, 1),
      0,
    ),
    Math.max(
      Math.min((event.clientY - iBounds[1]) / event.target.offsetHeight, 1),
      0,
    ),
  ];
};

export const getArrowStyle = (arrow: number[]) => {
  if (!Array.isArray(arrow) || arrow.length < 4) {
    return null;
  }

  const x1 = arrow[0] * 100;
  const y1 = arrow[1] * 100;
  const x2 = arrow[2] * 100;
  const y2 = arrow[3] * 100;

  return {
    x1,
    y1,
    x2,
    y2,
  };
};

export const parseDrawables = (value: string): DrawableCollection => {
  if (!value) {
    return {
      rectangles: [],
      arrows: [],
    };
  }

  const extract = (expression: RegExp) =>
    Array.from(value.matchAll(expression))
      .map((match) =>
        match[1]
          .split(',')
          .map((item) => parseFloat(item.trim()))
          .filter((item) => !Number.isNaN(item)),
      )
      .filter((shape) => shape.length === 4);

  return {
    rectangles: extract(/Rect\(([^)]*)\)/gi),
    arrows: extract(/Arrow\(([^)]*)\)/gi),
  };
};
